export default class PurchaseOrderStatus {
    constructor() {

        this.statusCode = '';
        this.statusText = '';
        this.user = '';
        this.date = '';
        this.comment = '';
    }
}
